import './App.css';
import Battle from './pages/Battle';

function App() {
  return <Battle />;
}

export default App;
